// hooks/useConfirmSubmit.js
import { useState, useCallback } from "react";

const useConfirmSubmit = (onConfirmedSubmit) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);

  // Pass this as Formik's onSubmit — it intercepts and opens the modal
  const handleFormSubmit = useCallback((values) => {
    setPendingValues(values);
    setShowConfirm(true);
  }, []);

  // Called when user clicks "Save" in the modal
  const handleConfirm = useCallback(() => {
    if (pendingValues !== null) {
      onConfirmedSubmit(pendingValues);
    }
    setShowConfirm(false);
    setPendingValues(null);
  }, [pendingValues, onConfirmedSubmit]);

  const handleCancel = useCallback(() => {
    setShowConfirm(false);
    setPendingValues(null);
  }, []);

  return { showConfirm, handleFormSubmit, handleConfirm, handleCancel };
};

export default useConfirmSubmit;